import { TransactionalCurrency } from '../types/enums';

const formatCurrency = (
  amount: number,
  currencyEnum: TransactionalCurrency = TransactionalCurrency.GBP
) => {
  let currency = 'GBP';

  switch (currencyEnum) {
    case TransactionalCurrency.EUR:
      currency = 'EUR';
      break;
    case TransactionalCurrency.GBP:
    default:
      currency = 'GBP';
      break;
    case TransactionalCurrency.AED:
      currency = 'AED';
      break;
  }

  // numeral(amount).format('0.00');
  return amount?.toLocaleString(undefined, {
    style: 'currency',
    currency
  });
};
export default formatCurrency;

export function createCurrencyCode(currencyEnum: TransactionalCurrency) {
  switch (currencyEnum) {
    case TransactionalCurrency.GBP:
      return 'GBP';
    case TransactionalCurrency.EUR:
      return 'EUR';
    case TransactionalCurrency.AED:
      return 'AED';
    default:
      return 'GBP';
  }
}
